import { FunctionComponent } from 'react';
import { EducatorForm } from '../EducatorForm';
import { DefaultForm } from '../DefaultForm';
import { CademyError } from '@shared/domain-shared';

export type GuestFormProps = {
    formId: string | null;
    error: CademyError | null;
};

export const GuestForm: FunctionComponent<GuestFormProps> = ({ formId, error }) => {
    if (formId === null) {
        return <DefaultForm error={error} />;
    }
    return <EducatorForm formId={formId} error={error} />;
};
